import React, { Component } from 'react'
import { connect } from 'react-redux'
import Invoices from './Invoices'
import LinearProgess from 'material-ui/Progress/LinearProgress'
import KeyboardBackspaceIcon from 'material-ui-icons/KeyboardBackspace'
import { Link } from 'react-router-dom'
import Button from 'material-ui/Button'

class InvoicesContainer extends Component {
  render () {
    const {
      job,
      isJobsRequestOngoing
    } = this.props

    if (isJobsRequestOngoing) {
      return <LinearProgess />
    }

    const goBack = <Link to='/jobs'><Button color='primary'><KeyboardBackspaceIcon /> Go Back </Button></Link>

    if (!job) {
      return <div>{goBack}<h4> No Job found</h4></div>
    }

    return (
      <div>
        {goBack}
        <h4>Invoices for {job.job.title}</h4>
        <Invoices invoices={job.invoices} />
      </div>
    )
  }
}

const mapStateToProps = ({jobs: {isJobsRequestOngoing, jobs}}, { match: { params } }) => ({
  isJobsRequestOngoing,
  job: jobs.find(job => job.job._id === decodeURIComponent(params.jobId))
})

export default connect(mapStateToProps)(InvoicesContainer)



// WEBPACK FOOTER //
// ./src/jobs/InvoicesContainer.js